import { forwardRef } from 'react';

import type { IconProps } from './types';

export const Upload = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', ...props }, forwardedRef) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 1024 1024"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    ref={forwardedRef}
  >
    <path
      d="M947.203 419.328H799.231c-121.344 0-220.159-98.817-220.159-220.16V51.2c0-28.16-23.04-51.2-51.201-51.2H310.783C153.087 0 25.599 102.4 25.599 285.184v453.63C25.599 921.598 153.087 1024 310.783 1024h402.431C870.912 1024 998.4 921.598 998.4 738.814V470.528c0-28.16-23.04-51.2-51.198-51.2zm-459.267 171.01c-7.68 7.68-17.407 11.262-27.136 11.262s-19.455-3.582-27.136-11.262L396.8 553.471v214.527c0 20.994-17.407 38.4-38.4 38.4s-38.4-17.406-38.4-38.4V553.471l-36.864 36.867c-14.848 14.844-39.424 14.844-54.272 0a38.604 38.604 0 0 1 0-54.274l102.399-102.4c3.585-3.072 7.168-5.632 11.263-7.68 1.024-.512 2.561-1.024 3.585-1.536 3.072-1.024 6.144-1.536 9.728-2.048h4.096c4.096 0 8.192 1.024 12.288 2.56h1.024c4.095 1.536 8.192 4.608 11.263 7.68.512.512 1.024.512 1.024 1.024l102.399 102.4c14.848 14.848 14.848 39.424 0 54.274z"
      fill={color}
    />
    <path
      d="M790.009 348.668c48.642.512 116.226.512 174.084.512 29.184 0 44.544-34.304 24.06-54.784-73.728-74.24-205.824-207.872-281.598-283.648-20.994-20.992-57.342-6.656-57.342 22.529v178.688c0 74.752 63.486 136.704 140.796 136.704z"
      fill={color}
    />
  </svg>
));

export default Upload;
